import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        await api.post("/auth/emergent-session", { session_id: sessionId });
        await checkAuth();
        toast.success("Accesso con Google riuscito!");
        // Clear hash and navigate
        window.history.replaceState(null, "", "/profile");
        navigate("/profile", { replace: true });
      } catch {
        toast.error("Autenticazione Google fallita");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, checkAuth]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-xs uppercase tracking-widest text-neutral-500">Autenticazione in corso...</p>
      </div>
    </div>
  );
}
